module.exports = __webpack_public_path__ + "media/images/home-top1-5d7a842fa4ab42e438421abeefb217cc.png";